<mat-toolbar color="accent" class="min-h-[50px]">
  {{ data?.task ? 'Edit' : 'Add' }} Task
</mat-toolbar>

<div class="flex flex-col overflow-scroll bg-slate-100">
  <pr-generated-task-edit
    #form="prGeneratedTaskEdit"
    context="appointment"
    [task]="data?.task"
    [useRelativeTime]="data?.useRelativeTime"
    [triggerDate]="data?.triggerDate"
    [configRef]="data?.configRef"
    [practices]="data?.practices"
    [scope]="appointmentScope"
  />
</div>
<pt-page-footer>
  <pt-buttons-container padding="none">
    <button type="button" mat-stroked-button mat-dialog-close>Cancel</button>
    <button
      type="submit"
      mat-flat-button
      color="primary"
      [disabled]="form.form.invalid"
      (click)="save(form)"
    >
      Save
    </button>
  </pt-buttons-container>
</pt-page-footer>
